import { render, staticRenderFns } from "./productsOfSeller.vue?vue&type=template&id=e0b68bea&scoped=true&"
import script from "./productsOfSeller.vue?vue&type=script&lang=ts&"
export * from "./productsOfSeller.vue?vue&type=script&lang=ts&"
import style0 from "./productsOfSeller.vue?vue&type=style&index=0&id=e0b68bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b68bea",
  null
  
)

export default component.exports